import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="localstorage" id="localstorage"></a>
    <h1 {...{
      "id": "windowlocalstorage"
    }}>{`window.localStorage`}</h1>
    <p>{`Provides a local key-value store useful for setting preferences and other kinds of data.
This data is technically persistent, but can be cleared in a variety of ways,
so you should not store data using localStorage that you cannot otherwise reconstruct.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Do not store passwords or other secure forms of data using `}<inlineCode parentName="p">{`localStorage`}</inlineCode>{`. Instead, use `}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Key-Value%20Storage/SecureStorage/"
      }}>{`storage.secureStorage`}</a>{`.`}</p>
    <a name="localstorage-length" id="localstorage-length"></a>
    <h2 {...{
      "id": "length--int"
    }}>{`length ⇒ `}<inlineCode parentName="h2">{`int`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns number of items stored in the local storage.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`int`}</inlineCode>{` - returns the number of items  `}</p>
    <a name="localstorage-key" id="localstorage-key"></a>
    <h2 {...{
      "id": "key"
    }}>{`key()`}</h2>
    <p>{`Returns key which is stored at the given index`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`int`}</inlineCode>{` - Returns key which is stored at the given index.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-getitem" id="localstorage-getitem"></a>
    <h2 {...{
      "id": "getitemkey"
    }}>{`getItem(key)`}</h2>
    <p>{`Get value from the local storage for the key.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - returns value corresponding to the key as string. If key doesn't exist, this function returns null.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A key to get value.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-setitem" id="localstorage-setitem"></a>
    <h2 {...{
      "id": "setitemkey-value"
    }}>{`setItem(key, value)`}</h2>
    <p>{`Set key and value to the local storage.
If the key is newly set or value is different from old value, an update event will be fired later.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` throw an error if fails to store`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A key to set value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A value for the key`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-removeitem" id="localstorage-removeitem"></a>
    <h2 {...{
      "id": "removeitemkey"
    }}>{`removeItem(key)`}</h2>
    <p>{`Remove a key/value pair from the local storage.
If the key exists in the local storage, an update event will be fired later.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A key to set value`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-clear" id="localstorage-clear"></a>
    <h2 {...{
      "id": "clear"
    }}>{`clear()`}</h2>
    <p>{`Remove all key/value pairs from the local storage.
An update event will be fired later.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      